import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0A1628] border-t border-white/10" data-testid="footer">
      <div className="max-w-[1200px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Platform */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-6">Platform</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/platform" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Platform
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/use-cases" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Use Cases
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Case Studies
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Column 2 - Solutions */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-6">Solutions</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/solutions/financial-data-intelligence" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Financial Data Intelligence
                </Link>
              </li>
              <li>
                <Link to="/solutions/ops-intelligence-suite" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Ops Intelligence Suite
                </Link>
              </li>
              <li>
                <Link to="/solutions/agentic-coworkers" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Agentic Co-workers
                </Link>
              </li>
              <li>
                <Link to="/solutions/financial-intelligence-assistant" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Financial Intelligence Assistant
                </Link>
              </li>
              <li>
                <Link to="/solutions/aureon" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Aureon (MRM)
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Column 3 - Company */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Resources & Insights
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Column 4 - Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-6">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="mailto:info@cognifin.tech" 
                  className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm"
                >
                  info@cognifin.tech
                </a>
              </li>
              <li>
                <a 
                  href="https://cognifin.tech" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm"
                >
                  cognifin.tech
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-[#9CA3AF] hover:text-[#1A56DB] transition-colors text-sm">
                  Request Demo
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col items-center md:items-start gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_nav-routing-upgrade/artifacts/decdjpmm_Logo%20H_without%20tagline.png" 
              alt="Cognifin" 
              className="h-6"
            />
            <p className="text-[#9CA3AF] text-xs italic">
              The Financial Intelligence Platform. Human at the Centre.
            </p>
            <span className="text-[#9CA3AF] text-sm mt-2">
              © 2026 Cognifin Technologies Pvt. Ltd.
            </span>
          </div>
          <div className="flex flex-wrap justify-center md:justify-end items-center gap-x-6 gap-y-2 text-sm text-[#9CA3AF] text-center">
            <a href="https://cognifin.tech" className="hover:text-[#1A56DB] transition-colors">
              cognifin.tech
            </a>
            <span className="hidden sm:inline text-white/20">|</span>
            <a href="mailto:info@cognifin.tech" className="hover:text-[#1A56DB] transition-colors">
              info@cognifin.tech
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
